import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import PasswordMask from '../../../assets/img/password-mask.png'
import PasswordUnmask from '../../../assets/img/password-unmask.png'

const SvgBase = styled.svg`
  min-width: 1em;
  height: 1em;
  vertical-align: middle;
`

const IconBase = styled.span`
  display: inline-block;
  min-width: 1em;
  height: 1em;
  vertical-align: middle;
`

const SvgPath = styled.path`
  fill: currentColor;
`

const SvgRect = styled.rect`
  fill: currentColor;
`

function Icon(props) {
  const { name, ...restProps } = props

  switch (name) {
    case 'facebook':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="15 10 15 30">
          <SvgPath d="M26 20v-3c0-1.3.3-2 2.4-2H31v-5h-4c-5 0-7 3.3-7 7v3h-4v5h4v15h6V25h4.4l.6-5h-5z" />
        </SvgBase>
      )
    case 'google':
      return (
        <SvgBase viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
          <SvgPath d="M491.4,210.1c-76.8,0-153.6,0-230.5,0c0,31.9,0,63.7,0,95.6c44.5,0,89,0,133.5,0c-5.2,30.5-23.3,58.5-49,75.6  c-16.2,10.9-34.8,17.9-53.9,21.3c-19.3,3.3-39.2,3.7-58.4-0.2c-19.6-3.9-38.2-12.1-54.5-23.5c-26-18.3-45.9-45.1-56.1-75.2  c-10.4-30.6-10.5-64.8,0-95.4c7.3-21.6,19.5-41.5,35.5-57.7c19.8-20.2,45.5-34.7,73.1-40.6c23.7-5.1,48.7-4.1,71.9,2.9  c19.7,6,37.9,16.8,52.8,31c15.1-15,30-30,45.1-45c7.9-8.1,16.2-15.8,23.8-24.1c-22.8-21.1-49.6-38.1-78.8-48.8  c-52.6-19.4-112-19.8-165-1.4C121.1,45,70.3,89.6,42.1,146.1c-9.8,19.4-17,40.2-21.3,61.6C10,260.8,17.5,317.5,42.1,366  c15.9,31.6,38.8,59.7,66.5,81.8c26.2,20.9,56.7,36.3,89,44.9c40.8,10.9,84.2,10.7,125.3,1.3c37.1-8.5,72.2-26.3,100.3-52.2  c29.6-27.2,50.8-63.1,62-101.7C497.3,298.1,499,253.2,491.4,210.1z" />
        </SvgBase>
      )
    case 'apple':
      return (
        <SvgBase viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          {/* <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> */}
          <g id="siwa" transform="translate(-12, -10)">
            {/* <rect id="Rectangle" fill="#000000" x="0" y="0" width="44" height="44"></rect> */}
            <SvgPath d="M22.2226562,14.3846154 C23.0546875,14.3846154 24.0976562,13.8048315 24.71875,13.0317864 C25.28125,12.3312142 25.6914062,11.352829 25.6914062,10.3744437 C25.6914062,10.2415766 25.6796875,10.1087095 25.65625,10 C24.7304687,10.0362365 23.6171875,10.640178 22.9492187,11.4494596 C22.421875,12.06548 21.9414062,13.0317864 21.9414062,14.0222505 C21.9414062,14.1671964 21.9648438,14.3121424 21.9765625,14.3604577 C22.0351562,14.3725366 22.1289062,14.3846154 22.2226562,14.3846154 Z M19.2929688,29 C20.4296875,29 20.9335938,28.214876 22.3515625,28.214876 C23.7929688,28.214876 24.109375,28.9758423 25.375,28.9758423 C26.6171875,28.9758423 27.4492188,27.792117 28.234375,26.6325493 C29.1132812,25.3038779 29.4765625,23.9993643 29.5,23.9389701 C29.4179688,23.9148125 27.0390625,22.9122695 27.0390625,20.0979021 C27.0390625,17.6579784 28.9140625,16.5588048 29.0195312,16.474253 C27.7773438,14.6382708 25.890625,14.5899555 25.375,14.5899555 C23.9804688,14.5899555 22.84375,15.4596313 22.1289062,15.4596313 C21.3554688,15.4596313 20.3359375,14.6382708 19.1289062,14.6382708 C16.8320312,14.6382708 14.5,16.5950413 14.5,20.2911634 C14.5,22.5861411 15.3671875,25.013986 16.4335938,26.5842339 C17.3476562,27.9129053 18.1445312,29 19.2929688,29 Z" />
          </g>
          {/* </g> */}
        </SvgBase>
      )
    case 'appstore':
      return (
        <SvgBase viewBox="0 0 19.5256877 24" xmlns="http://www.w3.org/2000/svg">
          <g
            id="Simplified-Login/Registration-Web"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="Success-page"
              transform="translate(-966.000000, -529.000000)"
              fill="#FFFFFF"
              fill-rule="nonzero"
            >
              <g id="Group-4" transform="translate(945.000000, 515.000000)">
                <g id="6424299" transform="translate(21.000000, 14.000000)">
                  <SvgPath
                    d="M16.3087483,12.7627593 C16.3327479,10.8927946 17.3127294,9.16582713 18.9056994,8.1868456 C17.8967184,6.74487279 16.2657492,5.86388941 14.5067823,5.80889044 C12.6558172,5.6148941 10.8618511,6.91586957 9.91886886,6.91586957 C8.95788699,6.91586957 7.50591437,5.82789009 5.94194387,5.85988948 C3.88498266,5.92688822 2.01301797,7.0678667 1.01203685,8.86683277 C-1.11892296,12.5567632 0.470047069,17.9806609 2.51200856,20.9636046 C3.53398928,22.4245771 4.72696678,24.0555463 6.28993731,23.9985474 C7.81890847,23.9355486 8.3898977,23.0235658 10.2348629,23.0235658 C12.0628284,23.0235658 12.5988183,23.9985474 14.1927883,23.9615481 C15.8327573,23.9345486 16.8667378,22.4945758 17.8527192,21.0196036 C18.5867054,19.9786232 19.1516947,18.8286449 19.5256877,17.6116678 C17.5777244,16.7876834 16.3107483,14.8787194 16.3087483,12.7627593 Z"
                    id="_Path_"
                  />
                  <SvgPath
                    d="M13.2978051,3.84692745 C14.1917883,2.7729477 14.63278,1.39297373 14.525782,0 C13.1598077,0.143997284 11.8968316,0.796984969 10.9908486,1.82896551 C10.0958655,2.84794629 9.64187409,4.17992117 9.72987243,5.53389563 C11.1148463,5.54789537 12.4298215,4.9259071 13.2978051,3.84692745 Z"
                    id="_Path_2"
                  />
                </g>
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'playstore':
      return (
        <SvgBase viewBox="0 0 22.2852837 24" xmlns="http://www.w3.org/2000/svg">
          <g
            id="Simplified-Login/Registration-Web"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="Success-page"
              transform="translate(-1165.000000, -530.000000)"
              fill="#FFFFFF"
              fill-rule="nonzero"
            >
              <g id="Group-4" transform="translate(945.000000, 515.000000)">
                <g id="Group" transform="translate(201.000000, 0.000000)">
                  <g
                    id="logo-google-playstore"
                    transform="translate(19.000000, 15.000000)"
                  >
                    <SvgPath d="M0,1.47281869 L0,22.5261099 C0.000288381102,22.6194999 0.0565548232,22.7036091 0.142764877,22.7395202 C0.228974931,22.7754313 0.328313297,22.7561399 0.394816173,22.690572 L11.3569917,12 L0.394816173,1.3083566 C0.328313297,1.2427887 0.228974931,1.22349724 0.142764877,1.25940834 C0.0565548232,1.29531945 0.000288381102,1.37942866 0,1.47281869 Z" />
                    <SvgPath d="M15.9533591,7.60720133 L2.20818489,0.0344449815 L2.19961358,0.0296236171 C1.96283102,-0.0989461002 1.73783401,0.221406779 1.93176,0.407832869 L12.706438,10.7105529 L15.9533591,7.60720133 Z" />
                    <SvgPath d="M1.93283142,23.5921671 C1.73783401,23.7785932 1.96283102,24.0989461 2.20068499,23.9703764 L2.20925631,23.965555 L15.9533591,16.3927987 L12.706438,13.2883757 L1.93283142,23.5921671 Z" />
                    <SvgPath d="M21.5022138,10.6607321 L17.663872,8.54683168 L14.0548129,12 L17.663872,15.4515612 L21.5022138,13.3392679 C22.546307,12.7623113 22.546307,11.2376887 21.5022138,10.6607321 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'desktop':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none" />
          <SvgPath d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z" />
        </SvgBase>
      )
    case 'mobile':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <SvgPath d="M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </SvgBase>
      )
    case 'x':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <SvgPath d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </SvgBase>
      )
    case 'plus':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36.01">
          <SvgPath d="M36 16.01 20 16 20 0 16 0 16 16 0 16.01 0 20 16 20 16 36 20 36 20 20 36 20 36 16.01z" />
        </SvgBase>
      )
    case 'minus':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
          <SvgRect y="15.99" width="36" height="4" />
        </SvgBase>
      )
    case 'full-view':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
          <SvgPath d="M9.29,34.29,7,32l9-9-3-3L4,29,1.78,26.22A1,1,0,0,0,0,26.85V36H8.58A1,1,0,0,0,9.29,34.29ZM36,36V26.86a1,1,0,0,0-1.78-.63L32,29l-9-9-3,3,9,9-2.77,2.22A1,1,0,0,0,26.85,36ZM26.22,1.77,29,4l-9,9,3,3,9-9,2.22,2.78A1,1,0,0,0,36,9.15V0H26.84A1,1,0,0,0,26.22,1.77ZM0,0V9c0,.94,1.41,1.73,2,1L4,7l9,9,3-3L7,4l3-2c.74-.59-.05-2-1-2Z" />
        </SvgBase>
      )
    case 'web-link':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <SvgPath d="M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z" />
          <path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none" />
        </SvgBase>
      )
    case 'location':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <SvgPath d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </SvgBase>
      )
    case 'phone':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <SvgPath d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </SvgBase>
      )
    case 'social-media':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <SvgPath d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </SvgBase>
      )
    case 'caret':
      return (
        <IconBase {...restProps}>
          <span
            style={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <span
              style={{
                borderTop: '0.35em solid transparent',
                borderRight: '0.35em solid transparent',
                borderLeft: '0.35em solid currentColor',
                borderBottom: '0.35em solid currentColor',
                transform: 'rotate(-45deg)',
                display: 'inline-block',
                position: 'absolute',
                top: '-1em',
                left: '0.15em',
              }}
            />
          </span>
        </IconBase>
      )
    case 'arrow-right':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12">
          <SvgPath
            transform="translate(3.500000, 6.000000) scale(-1, -1) translate(-3.500000, -6.000000)"
            d="M6.5 0.5 0.5 6.39285714 6.5 11.5"
          />
        </SvgBase>
      )
    case 'arrow-left':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12">
          <SvgPath d="M6.5 0.5 0.5 6.39285714 6.5 11.5" />
        </SvgBase>
      )
    case 'compass':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 49">
          <g transform="translate(-947.000000, -359.000000)">
            <SvgPath d="M962.5,405 C971.060414,405 978,398.060414 978,389.5 C978,383.793058 972.833333,373.884022 962.5,359.772892 C952.166667,373.884022 947,383.793058 947,389.5 C947,398.060414 953.939586,405 962.5,405 Z" />
          </g>
        </SvgBase>
      )
    case 'accessible':
      return (
        <SvgBase viewBox="0 0 20 24">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(-36.000000, -620.000000)"
              fill="currentColor"
              fillRule="nonzero"
            >
              <g transform="translate(36.000000, 620.000000)">
                <SvgPath d="M8.5164404,4.64516129 C9.79773867,4.64516129 10.8387097,3.60530206 10.8387097,2.3226046 C10.8387097,1.03952389 9.79773867,0 8.5164404,0 C7.23365715,0 6.19354839,1.03952389 6.19354839,2.3226046 C6.19354839,3.60530206 7.23365715,4.64516129 8.5164404,4.64516129 Z" />
                <SvgPath d="M12.3258973,18.2866867 C11.697886,20.411338 9.68764545,21.9716733 7.30755926,21.9716733 C4.42532728,21.9716733 2.08141158,19.6877634 2.08141158,16.8802903 C2.08141158,14.8020914 3.36814491,13.0133889 5.20445514,12.2229855 L5.20445514,10.0645161 C2.19723513,10.9470643 0,13.6670473 0,16.8802903 C0,20.8058985 3.27810868,24 7.30751051,24 C10.2439495,24 12.7749573,22.2995475 13.9354839,19.8597038 L13.1103873,18.2801796 C12.878789,18.282032 12.6104839,18.2844069 12.3258973,18.2866867 Z" />
                <SvgPath d="M19.2076008,20.4565855 L16.1371275,14.3021098 C15.9079496,13.8416039 15.4446765,13.551745 14.9379035,13.551745 L11.0052825,13.551745 L11.0052825,12.637482 L14.3898529,12.637482 C14.7278277,12.637482 15.0119004,12.4573868 15.1954035,12.1979455 C15.3146498,12.0289375 15.3994745,11.832597 15.3994745,11.6081046 C15.3994745,11.0398115 14.9479746,10.5788718 14.3898529,10.5788718 L12.3507984,10.5788718 L11.0052825,10.5788718 L11.0052825,7.47791687 C11.0052825,6.6250675 10.3850317,5.41935484 8.98684322,5.41935484 C7.87173457,5.41935484 6.96774194,6.34113789 6.96774194,7.47791687 L6.96774194,14.1963954 C6.96774194,15.3561202 7.88989102,16.2962695 9.02745882,16.2962695 L12.7280176,16.2962695 L14.1126361,16.2962695 L16.8088689,21.7009107 C17.0458011,22.1769387 17.5186253,22.4516129 18.0093223,22.4516129 C18.2150009,22.4516129 18.4235636,22.4036968 18.6184618,22.3019834 C19.2820233,21.9588576 19.5455755,21.1321356 19.2076008,20.4565855 Z" />
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'smiley':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <SvgPath d="M10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C15.5,20 20,15.5 20,10 C20,4.5 15.5,0 10,0 Z M13.5,6 C14.3,6 15,6.7 15,7.5 C15,8.3 14.3,9 13.5,9 C12.7,9 12,8.3 12,7.5 C12,6.7 12.7,6 13.5,6 Z M6.5,6 C7.3,6 8,6.7 8,7.5 C8,8.3 7.3,9 6.5,9 C5.7,9 5,8.3 5,7.5 C5,6.7 5.7,6 6.5,6 Z M10,16 C7.4,16 5.2,14.3 4.4,12 L15.6,12 C14.8,14.3 12.6,16 10,16 Z" />
        </SvgBase>
      )
    case 'cardview':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <SvgPath d="M0,5 L5,5 L5,0 L0,0 L0,5 Z M7.5,20 L12.5,20 L12.5,15 L7.5,15 L7.5,20 Z M0,20 L5,20 L5,15 L0,15 L0,20 Z M0,12.5 L5,12.5 L5,7.5 L0,7.5 L0,12.5 Z M7.5,12.5 L12.5,12.5 L12.5,7.5 L7.5,7.5 L7.5,12.5 Z M15,0 L15,5 L20,5 L20,0 L15,0 Z M7.5,5 L12.5,5 L12.5,0 L7.5,0 L7.5,5 Z M15,12.5 L20,12.5 L20,7.5 L15,7.5 L15,12.5 Z M15,20 L20,20 L20,15 L15,15 L15,20 Z" />
        </SvgBase>
      )
    case 'share':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17">
          <SvgPath d="M12.9617582,10.88 C11.9876923,10.88 11.1191209,11.3441758 10.5635165,12.0615385 L5.91120879,9.46285714 C6.02021978,9.14989011 6.08,8.81230769 6.08,8.46417582 C6.08,8.11252747 6.02021978,7.77846154 5.90769231,7.46197802 L10.5564835,4.86681319 C11.1085714,5.58769231 11.9806593,6.05538462 12.9582418,6.05538462 C14.6250549,6.05538462 15.9859341,4.69802198 15.9859341,3.02769231 C15.9859341,1.35736264 14.6285714,0 12.9582418,0 C11.2879121,0 9.93054945,1.35736264 9.93054945,3.02769231 C9.93054945,3.37934066 9.99032967,3.71692308 10.1028571,4.02989011 L5.45758242,6.62505495 C4.90549451,5.90065934 4.03340659,5.43648352 3.05582418,5.43648352 C1.38901099,5.43648352 0.0281318681,6.79384615 0.0281318681,8.46417582 C0.0281318681,10.1345055 1.38901099,11.4918681 3.05934066,11.4918681 C4.03692308,11.4918681 4.90901099,11.0241758 5.46461538,10.2997802 L10.1134066,12.8984615 C10.0008791,13.2149451 9.93758242,13.556044 9.93758242,13.9076923 C9.93758242,15.5745055 11.2949451,16.9353846 12.9652747,16.9353846 C14.6356044,16.9353846 15.992967,15.578022 15.992967,13.9076923 C15.992967,12.2373626 14.6320879,10.88 12.9617582,10.88 Z M12.9617582,0.952967033 C14.1081319,0.952967033 15.04,1.88483516 15.04,3.03120879 C15.04,4.17758242 14.1081319,5.10945055 12.9617582,5.10945055 C11.8153846,5.10945055 10.8835165,4.17758242 10.8835165,3.03120879 C10.8835165,1.88483516 11.8189011,0.952967033 12.9617582,0.952967033 Z M3.05934066,10.5424176 C1.91296703,10.5424176 0.981098901,9.61054945 0.981098901,8.46417582 C0.981098901,7.3178022 1.91296703,6.38593407 3.05934066,6.38593407 C4.20571429,6.38593407 5.13758242,7.3178022 5.13758242,8.46417582 C5.13758242,9.61054945 4.2021978,10.5424176 3.05934066,10.5424176 Z M12.9617582,15.9824176 C11.8153846,15.9824176 10.8835165,15.0505495 10.8835165,13.9041758 C10.8835165,12.7578022 11.8153846,11.8259341 12.9617582,11.8259341 C14.1081319,11.8259341 15.04,12.7578022 15.04,13.9041758 C15.04,15.0505495 14.1081319,15.9824176 12.9617582,15.9824176 Z" />
        </SvgBase>
      )
    case 'slide-left':
      return (
        <SvgBase viewBox="0 0 14 24">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(-226.000000, -1621.000000)"
              fill="currentColor"
              fillRule="nonzero"
            >
              <g transform="translate(234.000000, 1633.000000) scale(-1, 1) translate(-234.000000, -1633.000000) translate(208.000000, 1607.000000)">
                <g transform="translate(23.000000, 26.000000) scale(1, -1) rotate(-45.000000) translate(-23.000000, -26.000000) translate(16.000000, 19.000000)">
                  <polygon points="11.5 -1.25 14.5 -1.25 14.5 14.25 11.5 14.25" />
                  <polygon points="-1.25 14.5 -1.25 11.5 14.25 11.5 14.25 14.5" />
                </g>
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'slide-right':
      return (
        <SvgBase viewBox="0 0 14 24" {...restProps}>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(-295.000000, -1621.000000)"
              fill="currentColor"
              fillRule="nonzero"
            >
              <g transform="translate(275.000000, 1607.000000)">
                <g transform="translate(23.000000, 26.000000) scale(1, -1) rotate(-45.000000) translate(-23.000000, -26.000000) translate(16.000000, 19.000000)">
                  <polygon points="11.5 -1.25 14.5 -1.25 14.5 14.25 11.5 14.25" />
                  <polygon points="-1.25 14.5 -1.25 11.5 14.25 11.5 14.25 14.5" />
                </g>
              </g>
            </g>
          </g>
        </SvgBase>
      )

    case 'clock':
      return (
        <SvgBase xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20">
          <SvgPath d="M7.99973333,0 C3.58165333,0 0,3.58176 0,7.99973333 C0,12.4177067 3.58165333,15.9997333 7.99973333,15.9997333 C12.4178133,15.9997333 15.9997333,12.4177067 15.9997333,7.99973333 C15.9997333,3.58176 12.4178133,0 7.99973333,0 Z M11.45824,9.52128 L8.06666667,9.52128 C8.0552,9.52128 8.04453333,9.51850667 8.03317333,9.51808 C8.02181333,9.51861333 8.0112,9.52128 7.99968,9.52128 C7.69413333,9.52128 7.4464,9.27354667 7.4464,8.968 L7.4464,3.31994667 C7.4464,3.0144 7.69413333,2.76666667 7.99968,2.76666667 C8.30522667,2.76666667 8.55296,3.0144 8.55296,3.31994667 L8.55296,8.41472 L11.4580267,8.41472 C11.7635733,8.41472 12.0113067,8.66245333 12.0113067,8.968 C12.0113067,9.27354667 11.7637867,9.52128 11.45824,9.52128 Z" />
          {/* <path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none" /> */}
        </SvgBase>
      )
    case 'search':
      return (
        <SvgBase viewBox="0 0 16 16">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-327.000000, -231.000000)" fill="#E3E3E3">
              <g transform="translate(327.000000, 231.000000)">
                <SvgPath d="M14.845058,14.9965359 L11.2888782,11.4118784 C13.7806246,8.8708948 13.8565519,4.79200345 11.4611443,2.15757559 C9.06573661,-0.476852274 5.04835369,-0.73270557 2.34639351,1.57708847 C-0.355566675,3.88688252 -0.784047531,7.94332094 1.37424415,10.7804494 C3.53253584,13.6175779 7.51231656,14.2294122 10.403682,12.1685961 L14.029138,15.8429675 C14.2566025,16.0577808 14.6110658,16.0514424 14.8309117,15.8286303 C15.0507575,15.6058182 15.0570116,15.2465724 14.845058,15.0160389 L14.845058,14.9965359 Z M1.25537099,6.73115039 C1.25537099,3.7152066 3.66772845,1.27030109 6.64352218,1.27030109 C9.61931592,1.27030109 12.0316734,3.7152066 12.0316734,6.73115039 C12.0316734,9.74709419 9.61931592,12.1919997 6.64352218,12.1919997 C3.66772845,12.1919997 1.25537099,9.74709419 1.25537099,6.73115039 Z" />
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'pencil':
      return (
        <SvgBase viewBox="0 0 12 12">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(-108.000000, -130.000000)"
              fill="#FFFFFF"
              fillRule="nonzero"
            >
              <g transform="translate(102.000000, 124.000000)">
                <g transform="translate(6.000000, 6.000000)">
                  <SvgPath d="M7.46189638,2.0026454 L9.90296784,4.45564876 L3.72394191,10.6649354 L1.28425447,8.21193199 L7.46189638,2.0026454 Z M11.7552689,1.41103724 L10.666645,0.31708196 C10.2459294,-0.105693987 9.56277427,-0.105693987 9.14062932,0.31708196 L8.09783645,1.36498172 L10.5389079,3.81800788 L11.7552689,2.59568996 C12.081577,2.26776101 12.081577,1.73894338 11.7552689,1.41103724 Z M0.00679292588,11.6598257 C-0.0376314435,11.8607372 0.142879426,12.0407641 0.342834466,11.9919042 L3.06299896,11.329138 L0.623311511,8.8761346 L0.00679292588,11.6598257 Z" />
                </g>
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'check':
      return (
        <SvgBase viewBox="0 0 9 8">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(-109.000000, -132.000000)"
              stroke="currentColor"
            >
              <g transform="translate(102.000000, 124.000000)">
                <g transform="translate(4.000000, 4.000000)">
                  <path d="M3.63636364 8.36363636 6.18181818 10.9090909 12 5.09090909" />
                </g>
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'info':
      return (
        <SvgBase viewBox="0 0 3 11">
          <g
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            fontFamily="Helvetica"
            fontSize="14"
            fontWeight="normal"
            letterSpacing="0.4666667"
          >
            <g
              transform="translate(-112.000000, -131.000000)"
              fill="currentColor"
            >
              <g transform="translate(102.000000, 124.000000)">
                <text>
                  <tspan x="10" y="18">
                    i
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'star':
      return (
        <SvgBase viewBox="0 0 25 23">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(-24.000000, -247.000000)"
              fill="currentColor"
              fillRule="nonzero"
            >
              <polygon points="36.5 265.75 29.1526843 269.612712 30.5558968 261.431356 24.6117935 255.637288 32.8263422 254.443644 36.5 247 40.1736578 254.443644 48.3882065 255.637288 42.4441032 261.431356 43.8473157 269.612712" />
            </g>
          </g>
        </SvgBase>
      )
    case 'warning':
      return (
        <SvgBase viewBox="0 0 458.096 555">
          <g>
            <SvgPath
              d="M454.106,396.635L247.33,38.496c-3.783-6.555-10.775-10.592-18.344-10.592c-7.566,0-14.561,4.037-18.344,10.592
              L2.837,398.414c-3.783,6.555-3.783,14.629,0,21.184c3.783,6.556,10.778,10.593,18.344,10.593h415.613c0.041,0,0.088,0.006,0.118,0
              c11.709,0,21.184-9.481,21.184-21.185C458.096,404.384,456.612,400.116,454.106,396.635z M57.872,387.822L228.986,91.456
              L400.1,387.828H57.872V387.822z M218.054,163.009h21.982c1.803,0,3.534,0.727,4.8,2.021c1.259,1.3,1.938,3.044,1.892,4.855
              l-4.416,138.673c-0.095,3.641-3.073,6.537-6.703,6.537h-13.125c-3.635,0-6.614-2.902-6.7-6.537l-4.418-138.673
              c-0.047-1.812,0.636-3.555,1.895-4.855C214.52,163.736,216.251,163.009,218.054,163.009z M246.449,333.502v25.104
              c0,3.699-2.997,6.696-6.703,6.696h-21.394c-3.706,0-6.7-2.997-6.7-6.696v-25.104c0-3.7,2.994-6.703,6.7-6.703h21.394
              C243.452,326.793,246.449,329.802,246.449,333.502z"
            />
          </g>
        </SvgBase>
      )
    case 'camera':
      return (
        <SvgBase viewBox="0 0 16 13">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(-224.000000, -289.000000)"
              fill="#F6F9FF"
              fillRule="nonzero"
            >
              <g transform="translate(224.000000, 289.000000)">
                <SvgPath d="M8,4.8 C6.6744,4.8 5.6,5.87488 5.6,7.2 C5.6,8.5256 6.6744,9.6 8,9.6 C9.32528,9.6 10.4,8.5256 10.4,7.2 C10.4,5.87488 9.32528,4.8 8,4.8 Z M14.4,2.4 L12.48,2.4 C12.216,2.4 11.93152,2.1952 11.84816,1.94464 L11.35184,0.4552 C11.26816,0.2048 10.984,0 10.72,0 L5.28,0 C5.016,0 4.73152,0.2048 4.64816,0.45536 L4.15184,1.9448 C4.06816,2.1952 3.784,2.4 3.52,2.4 L1.6,2.4 C0.72,2.4 0,3.12 0,4 L0,11.2 C0,12.08 0.72,12.8 1.6,12.8 L14.4,12.8 C15.28,12.8 16,12.08 16,11.2 L16,4 C16,3.12 15.28,2.4 14.4,2.4 Z M8,11.2 C5.79088,11.2 4,9.40912 4,7.2 C4,4.99104 5.79088,3.2 8,3.2 C10.2088,3.2 12,4.99104 12,7.2 C12,9.40912 10.2088,11.2 8,11.2 Z M13.84,5.11888 C13.53088,5.11888 13.28,4.86832 13.28,4.55888 C13.28,4.24976 13.53088,3.99888 13.84,3.99888 C14.14944,3.99888 14.4,4.24976 14.4,4.55888 C14.4,4.86832 14.14928,5.11888 13.84,5.11888 Z" />
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'v-ellipses':
      return (
        <SvgBase viewBox="0 0 4 20">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(-345.000000, -54.000000)"
              fill="currentColor"
            >
              <g transform="translate(345.000000, 54.000000)">
                <rect x="0" y="0" width="4" height="4" rx="2" />
                <rect x="0" y="8" width="4" height="4" rx="2" />
                <rect x="0" y="16" width="4" height="4" rx="2" />
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'switch':
      return (
        <SvgBase viewBox="0 0 24 24">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              transform="translate(-331.000000, -536.000000)"
              fill="currentColor"
              fillRule="nonzero"
            >
              <g transform="translate(343.500000, 548.000000) scale(1, -1) translate(-343.500000, -548.000000) translate(331.000000, 536.000000)">
                <g transform="translate(11.675418, 0.000000)">
                  <SvgPath d="M11.8807446,5.24574702 L6.99293556,0.357880668 C6.99270644,0.357651551 6.99247733,0.357536993 6.99230549,0.357307876 C6.96400955,0.329069212 6.9343389,0.302319809 6.90340811,0.276945107 C6.88926014,0.265317422 6.87436754,0.255236277 6.85981862,0.244353222 C6.84246301,0.231350835 6.82545107,0.217890215 6.80735084,0.205804296 C6.78993795,0.194176611 6.77189499,0.184095465 6.75402387,0.173441527 C6.737642,0.163646778 6.7216611,0.153393795 6.704821,0.144343675 C6.68660621,0.134606205 6.66793317,0.126357995 6.64931742,0.117594272 C6.6317327,0.109288783 6.61443437,0.10052506 6.59644869,0.0930214797 C6.57840573,0.085575179 6.55996181,0.07950358 6.54163246,0.072973747 C6.52232936,0.0660429594 6.50331265,0.0586539379 6.48360859,0.0526968974 C6.46527924,0.0471408115 6.44660621,0.0430739857 6.42810501,0.0384343675 C6.408,0.0333365155 6.38812411,0.0277231504 6.36767542,0.0236563246 C6.3461957,0.0194176611 6.32454415,0.0168400955 6.30294988,0.0137470167 C6.28513604,0.0112267303 6.26760859,0.00778997613 6.24950835,0.00601431981 C6.16931742,-0.0018902148 6.08849642,-0.0018902148 6.00830549,0.00601431981 C5.99026253,0.00778997613 5.97273508,0.0111694511 5.95486396,0.0137470167 C5.93326969,0.0168400955 5.91156086,0.0193603819 5.89013842,0.0236563246 C5.86963246,0.0277231504 5.84981384,0.0333365155 5.82970883,0.0384343675 C5.81115036,0.0430739857 5.79253461,0.0471408115 5.77420525,0.0526968974 C5.75450119,0.0586539379 5.73542721,0.0660429594 5.71618138,0.072973747 C5.69785203,0.0795608592 5.67940811,0.085575179 5.66136516,0.0930214797 C5.6433222,0.10046778 5.62608115,0.109288783 5.60849642,0.117594272 C5.58993795,0.126357995 5.57120764,0.134606205 5.55299284,0.144343675 C5.53615274,0.153393795 5.52017184,0.163646778 5.50378998,0.173441527 C5.48591885,0.184095465 5.46787589,0.194176611 5.45046301,0.205804296 C5.43236277,0.217890215 5.41540811,0.231350835 5.39799523,0.244353222 C5.3834463,0.255236277 5.3685537,0.265317422 5.35440573,0.276945107 C5.32347494,0.302319809 5.29374702,0.329069212 5.26550835,0.357307876 C5.26527924,0.357536993 5.26505012,0.357651551 5.26487828,0.357880668 L0.377069212,5.24568974 C-0.100124105,5.72288305 -0.100124105,6.49661098 0.377069212,6.9738043 C0.85426253,7.45099761 1.62799045,7.45099761 2.10518377,6.9738043 L4.90699761,4.17199045 L4.90699761,13.1742243 C4.90699761,13.8490883 5.4540716,14.3961623 6.12893556,14.3961623 C6.80379952,14.3961623 7.35087351,13.8490883 7.35087351,13.1742243 L7.35087351,4.17204773 L10.1526874,6.97386158 C10.6298807,7.45105489 11.4036086,7.45105489 11.8808019,6.97386158 C12.3579379,6.49661098 12.3579379,5.72294033 11.8807446,5.24574702 Z" />
                </g>
                <g transform="translate(6.500000, 16.500000) scale(1, -1) translate(-6.500000, -16.500000) translate(0.000000, 9.000000)">
                  <SvgPath d="M11.8807446,5.24574702 L6.99293556,0.357880668 C6.99270644,0.357651551 6.99247733,0.357536993 6.99230549,0.357307876 C6.96400955,0.329069212 6.9343389,0.302319809 6.90340811,0.276945107 C6.88926014,0.265317422 6.87436754,0.255236277 6.85981862,0.244353222 C6.84246301,0.231350835 6.82545107,0.217890215 6.80735084,0.205804296 C6.78993795,0.194176611 6.77189499,0.184095465 6.75402387,0.173441527 C6.737642,0.163646778 6.7216611,0.153393795 6.704821,0.144343675 C6.68660621,0.134606205 6.66793317,0.126357995 6.64931742,0.117594272 C6.6317327,0.109288783 6.61443437,0.10052506 6.59644869,0.0930214797 C6.57840573,0.085575179 6.55996181,0.07950358 6.54163246,0.072973747 C6.52232936,0.0660429594 6.50331265,0.0586539379 6.48360859,0.0526968974 C6.46527924,0.0471408115 6.44660621,0.0430739857 6.42810501,0.0384343675 C6.408,0.0333365155 6.38812411,0.0277231504 6.36767542,0.0236563246 C6.3461957,0.0194176611 6.32454415,0.0168400955 6.30294988,0.0137470167 C6.28513604,0.0112267303 6.26760859,0.00778997613 6.24950835,0.00601431981 C6.16931742,-0.0018902148 6.08849642,-0.0018902148 6.00830549,0.00601431981 C5.99026253,0.00778997613 5.97273508,0.0111694511 5.95486396,0.0137470167 C5.93326969,0.0168400955 5.91156086,0.0193603819 5.89013842,0.0236563246 C5.86963246,0.0277231504 5.84981384,0.0333365155 5.82970883,0.0384343675 C5.81115036,0.0430739857 5.79253461,0.0471408115 5.77420525,0.0526968974 C5.75450119,0.0586539379 5.73542721,0.0660429594 5.71618138,0.072973747 C5.69785203,0.0795608592 5.67940811,0.085575179 5.66136516,0.0930214797 C5.6433222,0.10046778 5.62608115,0.109288783 5.60849642,0.117594272 C5.58993795,0.126357995 5.57120764,0.134606205 5.55299284,0.144343675 C5.53615274,0.153393795 5.52017184,0.163646778 5.50378998,0.173441527 C5.48591885,0.184095465 5.46787589,0.194176611 5.45046301,0.205804296 C5.43236277,0.217890215 5.41540811,0.231350835 5.39799523,0.244353222 C5.3834463,0.255236277 5.3685537,0.265317422 5.35440573,0.276945107 C5.32347494,0.302319809 5.29374702,0.329069212 5.26550835,0.357307876 C5.26527924,0.357536993 5.26505012,0.357651551 5.26487828,0.357880668 L0.377069212,5.24568974 C-0.100124105,5.72288305 -0.100124105,6.49661098 0.377069212,6.9738043 C0.85426253,7.45099761 1.62799045,7.45099761 2.10518377,6.9738043 L4.90699761,4.17199045 L4.90699761,13.1742243 C4.90699761,13.8490883 5.4540716,14.3961623 6.12893556,14.3961623 C6.80379952,14.3961623 7.35087351,13.8490883 7.35087351,13.1742243 L7.35087351,4.17204773 L10.1526874,6.97386158 C10.6298807,7.45105489 11.4036086,7.45105489 11.8808019,6.97386158 C12.3579379,6.49661098 12.3579379,5.72294033 11.8807446,5.24574702 Z" />
                </g>
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'elevator':
      return (
        <SvgBase viewBox="0 0 18 24">
          <defs>
            <polygon
              id="path-1"
              points="5.0955414e-06 0.0488356688 17.9383949 0.0488356688 17.9383949 17.9872611 5.0955414e-06 17.9872611"
            />
          </defs>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-87.000000, -620.000000)">
              <g transform="translate(87.000000, 620.000000)">
                <SvgPath
                  d="M11.6879796,4.92824459 C11.3588586,4.92824459 11.0516994,4.79331465 10.8230115,4.54832102 L9.38795414,3.0107414 C9.1673172,2.77430828 9.18005605,2.40381146 9.41648917,2.18317452 C9.65287134,1.96248662 10.0234191,1.97527643 10.2440561,2.21170955 L11.6791643,3.74928917 C11.6839541,3.75443567 11.6871643,3.75637197 11.6884382,3.75703439 C11.6887439,3.75637197 11.6920051,3.75443567 11.6967949,3.74928917 L13.1419924,2.20090701 C13.3625783,1.96452484 13.7331261,1.95173503 13.9695592,2.17242293 C14.2059924,2.39305987 14.2187312,2.76355669 13.9980943,2.99993885 L12.5529478,4.54832102 C12.3242599,4.79331465 12.0171006,4.92824459 11.6879796,4.92824459"
                  fill="currentColor"
                />
                <SvgPath
                  d="M11.6930089,4.87193885 C11.3696459,4.87193885 11.1074803,4.60977325 11.1074803,4.28641019 L11.1074803,0.585518471 C11.1074803,0.262155414 11.3696459,4.07643312e-05 11.6930089,4.07643312e-05 C12.016372,4.07643312e-05 12.2785376,0.262155414 12.2785376,0.585518471 L12.2785376,4.28641019 C12.2785376,4.60977325 12.016372,4.87193885 11.6930089,4.87193885"
                  fill="currentColor"
                />
                <SvgPath
                  d="M6.24169682,2.5477707e-05 C6.57081783,2.5477707e-05 6.87797707,0.134904459 7.10666497,0.379898089 L8.54172229,1.91752866 C8.76235924,2.15391083 8.74962038,2.5244586 8.51318726,2.74509554 C8.27675414,2.96573248 7.90625732,2.95299363 7.68562038,2.71656051 L6.2505121,1.17892994 C6.24572229,1.17378344 6.2425121,1.17184713 6.24123822,1.17118471 C6.24088153,1.17184713 6.23767134,1.17378344 6.23288153,1.17892994 L4.78768408,2.7273121 C4.56709809,2.96374522 4.19655032,2.97653503 3.9601172,2.75584713 C3.72368408,2.53521019 3.71094522,2.16471338 3.93158217,1.92828025 L5.37672866,0.379898089 C5.60541656,0.134904459 5.9125758,2.5477707e-05 6.24169682,2.5477707e-05"
                  fill="currentColor"
                />
                <SvgPath
                  d="M6.23667261,0.0563312102 C6.56003567,0.0563312102 6.82220127,0.318496815 6.82220127,0.641859873 L6.82220127,4.34270064 C6.82220127,4.66606369 6.56003567,4.9282293 6.23667261,4.9282293 C5.91330955,4.9282293 5.65114395,4.66606369 5.65114395,4.34270064 L5.65114395,0.641859873 C5.65114395,0.318496815 5.91330955,0.0563312102 6.23667261,0.0563312102"
                  fill="currentColor"
                />
                <g transform="translate(0.000000, 5.970293)">
                  <mask fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>

                  <SvgPath
                    d="M14.733814,7.76980382 L14.733814,10.3395363 C14.733814,10.5797911 14.5390115,10.7745936 14.2987057,10.7745936 C14.058451,10.7745936 13.8635975,10.5797911 13.8635975,10.3395363 L13.8635975,7.95273376 C13.8635975,7.85168917 13.7817121,7.76980382 13.6807185,7.76980382 L13.6786803,7.76980382 C13.5776357,7.76980382 13.4957503,7.85168917 13.4957503,7.95273376 L13.4957503,14.0162242 C13.4957503,14.3291414 13.2420943,14.5827465 12.929228,14.5827465 C12.6163618,14.5827465 12.3627057,14.3291414 12.3627057,14.0162242 L12.3627057,10.8893452 C12.3627057,10.7836637 12.2770497,10.6980586 12.1714191,10.6980586 C12.0657885,10.6980586 11.9800815,10.7836637 11.9800815,10.8893452 L11.9800815,14.0162242 C11.9800815,14.3291414 11.7264764,14.5827465 11.4136102,14.5827465 C11.1007439,14.5827465 10.8470879,14.3291414 10.8470879,14.0162242 L10.8470879,7.95273376 C10.8470879,7.85168917 10.7652025,7.76980382 10.664158,7.76980382 C10.5631134,7.76980382 10.481228,7.85168917 10.481228,7.95273376 L10.481228,10.3395363 C10.481228,10.5797911 10.2864255,10.7745936 10.0461197,10.7745936 L10.0461197,10.7745936 C9.80581401,10.7745936 9.61101146,10.5797911 9.61101146,10.3395363 L9.61101146,7.76980382 L9.61101146,7.32873376 C9.61101146,6.84817325 10.0006166,6.45856815 10.4811771,6.45856815 L10.481228,6.45856815 L10.8470879,6.45856815 L11.9800815,6.45856815 L12.3627057,6.45856815 L13.4957503,6.45856815 L13.8635975,6.45856815 C14.3442089,6.45856815 14.733814,6.84817325 14.733814,7.32873376 L14.733814,7.76980382 Z M8.38813248,7.76980382 L8.38813248,10.3395363 C8.38813248,10.5797911 8.19338089,10.7745936 7.95307516,10.7745936 C7.71276943,10.7745936 7.51796688,10.5797911 7.51796688,10.3395363 L7.51796688,7.95273376 C7.51796688,7.85168917 7.43608153,7.76980382 7.33503694,7.76980382 L7.33299873,7.76980382 C7.2320051,7.76980382 7.15006879,7.85168917 7.15006879,7.95273376 L7.15006879,14.0162242 C7.15006879,14.3291414 6.89646369,14.5827465 6.5835465,14.5827465 C6.27068025,14.5827465 6.01707516,14.3291414 6.01707516,14.0162242 L6.01707516,10.8893452 C6.01707516,10.7836637 5.93136815,10.6980586 5.82573758,10.6980586 C5.72010701,10.6980586 5.63445096,10.7836637 5.63445096,10.8893452 L5.63445096,14.0162242 C5.63445096,14.3291414 5.38084586,14.5827465 5.06792866,14.5827465 C4.75506242,14.5827465 4.50140637,14.3291414 4.50140637,14.0162242 L4.50140637,7.95273376 C4.50140637,7.85168917 4.41952102,7.76980382 4.31847643,7.76980382 C4.2174828,7.76980382 4.1355465,7.85168917 4.1355465,7.95273376 L4.1355465,10.3395363 C4.1355465,10.5797911 3.9407949,10.7745936 3.70048917,10.7745936 C3.46018344,10.7745936 3.26538089,10.5797911 3.26538089,10.3395363 L3.26538089,7.76980382 L3.26538089,7.32873376 C3.26538089,6.84817325 3.65498599,6.45856815 4.1355465,6.45856815 L4.50140637,6.45856815 L5.63445096,6.45856815 L6.01707516,6.45856815 L7.15006879,6.45856815 L7.51796688,6.45856815 L7.51796688,6.45856815 C7.99852739,6.45856815 8.38813248,6.84817325 8.38813248,7.32873376 L8.38813248,7.76980382 Z M5.82675669,4.10193121 C6.4353172,4.10193121 6.92866752,4.59523057 6.92866752,5.20379108 C6.92866752,5.81235159 6.4353172,6.30570191 5.82675669,6.30570191 C5.21819618,6.30570191 4.72489682,5.81235159 4.72489682,5.20379108 C4.72489682,4.59523057 5.21819618,4.10193121 5.82675669,4.10193121 L5.82675669,4.10193121 Z M12.1723873,4.10193121 C12.7809478,4.10193121 13.2742981,4.59523057 13.2742981,5.20379108 C13.2742981,5.81235159 12.7809478,6.30570191 12.1723873,6.30570191 C11.5638777,6.30570191 11.0705274,5.81235159 11.0705274,5.20379108 C11.0705274,4.59523057 11.5638777,4.10193121 12.1723873,4.10193121 L12.1723873,4.10193121 Z M13.876693,0.0488356688 L4.0617121,0.0488356688 C1.82206879,0.0488356688 5.0955414e-06,1.87089936 5.0955414e-06,4.11054268 L5.0955414e-06,13.9255745 C5.0955414e-06,16.1651669 1.82206879,17.9872815 4.0617121,17.9872815 L13.876693,17.9872815 C16.1163363,17.9872815 17.9384,16.1651669 17.9384,13.9255745 L17.9384,4.11054268 C17.9384,1.87089936 16.1163363,0.0488356688 13.876693,0.0488356688 L13.876693,0.0488356688 Z"
                    fill="currentColor"
                    mask="url(#mask-2)"
                  />
                </g>
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'password-mask':
      return <img src={PasswordMask} alt="Password Mask" />
    case 'password-unmask':
      return <img src={PasswordUnmask} alt="Password Unmask" />
    case 'shop':
      return (
        <SvgBase viewBox="0 0 13 15">
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="Merchant-details-page-reservation"
              transform="translate(-28.000000, -623.000000)"
              fill="#5BBDAF"
              fill-rule="nonzero"
            >
              <g id="253298" transform="translate(28.000000, 623.000000)">
                <SvgPath
                  d="M11.9851214,4.06389429 C11.9805832,4.00326868 11.9298485,3.95637401 11.8691066,3.95637401 L9.77455561,3.95637401 L9.77455561,3.3745543 C9.77455561,1.51377851 8.26066074,2.98427949e-14 6.40000131,2.98427949e-14 C4.53934189,2.98427949e-14 3.02544701,1.51377851 3.02544701,3.3745543 L3.02544701,3.95637401 L0.930896063,3.95637401 C0.870154085,3.95637401 0.819419407,4.00326868 0.814881213,4.06389429 L0.000333622656,14.7693769 C-0.00211002012,14.8016097 0.00894455432,14.8334934 0.0310537032,14.8572317 C0.0530464881,14.8810863 0.0839992966,14.8945845 0.116348472,14.8945845 L12.6836542,14.8945845 C12.7160033,14.8945845 12.7469561,14.8810863 12.7689489,14.857348 C12.7909417,14.8336098 12.8021126,14.8017261 12.799669,14.7694933 L11.9851214,4.06389429 Z M3.95635854,3.3745543 C3.95635854,2.02717622 5.05250687,0.930911532 6.40000131,0.930911532 C7.74749575,0.930911532 8.84364408,2.02717622 8.84364408,3.3745543 L8.84364408,3.95637401 L3.95635854,3.95637401 L3.95635854,3.3745543 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </SvgBase>
      )
    case 'copy':
      return (
        <SvgBase
          {...restProps}
          viewBox="0 0 22 22"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Future-Sprints"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="GCASHxZING" transform="translate(-328.000000, -412.000000)">
              <g id="Group-2" transform="translate(58.000000, 405.000000)">
                <g id="copy" transform="translate(265.000000, 2.000000)">
                  <g id="Group" transform="translate(5.333333, 5.333333)">
                    <polygon
                      id="Path"
                      points="0 0 21.3333333 0 21.3333333 21.3333333 0 21.3333333"
                    ></polygon>
                    <path
                      d="M6.22222222,5.33333333 L6.22222222,2.66666667 C6.22222222,2.17574689 6.62019133,1.77777778 7.11111111,1.77777778 L17.7777778,1.77777778 C18.2686976,1.77777778 18.6666667,2.17574689 18.6666667,2.66666667 L18.6666667,15.1111111 C18.6666667,15.6020309 18.2686976,16 17.7777778,16 L15.1111111,16 L15.1111111,18.6666667 C15.1111111,19.1573333 14.7111111,19.5555716 14.216,19.5555716 L3.56177778,19.5555716 C3.3250253,19.5569748 3.09746951,19.4639796 2.92947434,19.2971522 C2.76147917,19.1303249 2.66689893,18.9034233 2.66666667,18.6666667 L2.66933333,6.22222222 C2.66933333,5.73155556 3.06933333,5.33333333 3.56444444,5.33333333 L6.22222222,5.33333333 Z M4.44711111,7.11111111 L4.44444444,17.7777778 L13.3333333,17.7777778 L13.3333333,7.11111111 L4.44711111,7.11111111 Z M8,5.33333333 L15.1111111,5.33333333 L15.1111111,14.2222222 L16.8888889,14.2222222 L16.8888889,3.55555556 L8,3.55555556 L8,5.33333333 Z"
                      id="Shape"
                      fill="#FFFFFF"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </SvgBase>
      )
    default:
      break
  }

  return <></>
}

Icon.propTypes = {
  // TODO: specify prop types
  name: PropTypes.string.isRequired,
}

export default Icon
